const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const SummaryCommand: any = {
    UpdateSummary: Backofficebff + '/v1/paymentConsolidation/save-payment-consolidation',
    PrintSummary: Backofficebff + '/v1/paymentConsolidation/update-payment-consolidation',
    AxaptaTransferSummary: Backofficebff + '/v1/paymentConsolidation/transfer-axapta',
    GetSummaryList: Backofficebff + '/v1/paymentConsolidation/search-payment-consolidation',
};
